import React from 'react';
import { Box, Typography, Paper, Grid } from '@mui/material';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';
import { StyledPaper } from '../../components/Paper';

const ledgerCategories = [
	{
		title: 'Operational Ledgers',
		items: [
			{ name: 'Inventory', amount: 2500000, trend: 'high' },
			{ name: 'Advance', amount: 850000, trend: 'high' },
			{ name: 'Incentive Fee Payable', amount: 175000, trend: 'loq' },
			{ name: 'Agency Fee Payable', amount: 2500000, trend: 'high' },
			{ name: 'VePay Revenue', amount: 850000, trend: 'high' },
			{ name: 'Marketplace Receivable', amount: 175000, trend: 'low' }
		],
		total: 1602500
	},
	{
		title: 'Wallets/Bank Account Ledgers',
		items: [
			{ name: 'VePay Capital (PingPong)', amount: 4500000, trend: 'high' },
			{ name: 'VePay Client Withdrawal (PingPong)', amount: 12500000, trend: 'high' },
			{ name: 'VePay Chase Bank', amount: 3750000, trend: 'low' },
			{ name: 'VePay Bank of Canada', amount: 25000000, trend: 'high' },
		],
		total: 69500000
	},
	{
		title: 'Control Accounts',
		items: [
			{ name: 'Amazon Reserve Release', amount: 15000000, trend: 'high' },
			{ name: 'Expected Marketplace Receivable', amount: 750000, trend: 'low' },
			{ name: 'Expected Revenue', amount: 15000000, trend: 'medium' },
			{ name: 'Expected Incentive Fee Payable', amount: 750000, trend: 'low' },
			{ name: 'Expected Agency Fee Payable', amount: 15000000, trend: 'high' },
			{ name: 'Capital Recovery', amount: 750000, trend: 'medium' },
			{ name: 'Incentive Adjustment', amount: 15000000, trend: 'high' },
			{ name: 'Return Revenue Receivable', amount: 750000, trend: 'low' },
			{ name: 'Allocation', amount: 15000000, trend: 'high' },
			{ name: 'Sales Order Adjustment', amount: 750000, trend: 'low' }
		
		],
		total: 15750000
	},
];
export default function LedgerView() {

	return (
		<Box>
			<Paper
				elevation={0}
				sx={{
					p: 3,
					mb: 4,
					borderRadius: 2,
					border: '1px solid',
					borderColor: 'grey.200',
					bgcolor: 'white'
				}}
			>
				<Grid container spacing={3}>
					<Grid item xs={12} md={6} lg={3}>
						<StyledPaper
							elevation={0}
						>
							<Typography variant="subtitle2" color="text.secondary">
								Total Balance
							</Typography>
							<Typography variant="h4" sx={{ my: 1}}>
								$54,956.74
							</Typography>
						</StyledPaper>
					</Grid>
					<Grid item xs={12} md={6} lg={3}>
						<StyledPaper
							elevation={0}
						>
							<Typography variant="subtitle2" color="text.secondary">
								Total Transactions
							</Typography>
							<Typography variant="h4" sx={{ my: 1}}>
								954
							</Typography>
						</StyledPaper>
					</Grid>
					<Grid item xs={12} md={6} lg={3}>
						<StyledPaper
							elevation={0}
						>
							<Typography variant="subtitle2" color="text.secondary">
								High Risk Ledgers
							</Typography>
							<Typography variant="h4" sx={{ my: 1}}>
								5
							</Typography>
						</StyledPaper>
					</Grid>
					<Grid item xs={12} md={6} lg={3}>
						<StyledPaper
							elevation={0}
						>
							<Typography variant="subtitle2" color="text.secondary">
								Pending Reconciliation
							</Typography>
							<Typography variant="h4" sx={{ my: 1}}>
								4
							</Typography>
						</StyledPaper>
					</Grid>
				</Grid>
			</Paper>

			{ledgerCategories.map((category, index) => (
				<Paper
					key={index}
					elevation={0}
					sx={{
						p: 3,
						mb: 3,
						borderRadius: 2,
						border: '1px solid',
						borderColor: 'grey.200',
						bgcolor: 'white'
					}}
				>
					<Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
						<Typography variant="h6" sx={{ fontWeight: 600 }}>
							{category.title}
						</Typography>
						<Typography variant="h6" sx={{ fontWeight: 600 }}>
							${(category.total / 1000000).toFixed(1)}
						</Typography>
					</Box>

					<Grid container spacing={3}>
						{category.items.map((item, itemIndex) => (
							<Grid item xs={12} sm={6} md={4} key={itemIndex}>
								<StyledPaper
									elevation={0}
									sx={{
										'&:hover': {
											transform: 'translateY(-2px)',
											boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
										},
									}}
								>
									<Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
										<Typography variant="subtitle2" color="text.secondary">
											{item.name}
										</Typography>
										{item.trend === 'high' ? (
											<ArrowUpRight className="w-4 h-4 text-green-500" />
										) : item.trend === 'low' ? (
											<ArrowDownRight className="w-4 h-4 text-red-500" />
										) : null}
									</Box>
									<Typography variant="h6" sx={{ fontWeight: 600 }}>
										${(item.amount / 1000000).toFixed(2)}
									</Typography>
								</StyledPaper>
							</Grid>
						))}
					</Grid>
				</Paper>
			))}
		</Box>
	);
}
